export const add = (a, b) => parseFloat((a + b).toFixed(4))
export const substract = (a, b) => parseFloat((a - b).toFixed(4))
export const multiply = (a, b) => parseFloat((a * b).toFixed(4))
export const devide = (top, bottom) => multiply(top, bottom) ? Number((top / bottom).toFixed(4)) : 0
export const precisionRound = (number, precision) => {
	var factor = Math.pow(10, precision)
	return Math.round(number * factor) / factor
}
